import CustomerIndex from "./CustomerIndex.vue";
import CustomerAdd from "./CustomerAdd.vue";
import CustomerDetail from "./CustomerDetail.vue";
import CustomerEdit from "./CustomerEdit.vue";
import CustomerUpload from "./CustomerUpload.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List Customer",
        },
        name: "WhMonitoring_CustomerIndex",
        component: CustomerIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Customer",
        },
        name: "WhMonitoring_CustomerAdd",
        component: CustomerAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Customer",
        },
        name: "WhMonitoring_CustomerDetail",
        component: CustomerDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Customer",
        },
        name: "WhMonitoring_CustomerEdit",
        component: CustomerEdit
    },
    {
        path: 'upload',
        meta: {
          title: "Upload Customer",
        },
        name: "WhMonitoring_CustomerUpload",
        component: CustomerUpload
    },
    
]

export default routes
  